/**
 * API plugin
 * To factorize all requests made by the dashboard to GMS
 * Each functions should:
 * - use the corresponding GMS API name
 * - return a Promise
 * - take at least one parameter: the object where to find the correct link
 * Usage:
 * - in Vue components: this.$api.[function]
 * - in stores or other JS modules: import {api} from '@/api' and api.[function]
 */
import alarms from './alarms'
import application from './application'
import auth from './auth'
import clusters from './clusters'
import customers from './customers'
import endDevice from './endDevice'
import fleets from './fleets'
import gateway from './gateway'
import kpi from './kpi'
import multicastGroups from './multicastGroups'
import selections from './selections'
import user from './user'
import wanesyGeolocation from './wanesyGeolocation'
import workflows from './workflows'
import softwares from './softwares'

const api = {
  ...alarms,
  ...application,
  ...auth,
  ...clusters,
  ...customers,
  ...endDevice,
  ...fleets,
  ...gateway,
  ...kpi,
  ...multicastGroups,
  ...selections,
  ...user,
  ...wanesyGeolocation,
  ...workflows,
  ...softwares
}

const WmcApi = {
  install: (Vue, options) => {
    Vue.prototype.$api = api
  }
}

// To be used is modules with import {api} from '@/api' and api.[function]
export { api }
// To be used in components with this.$api.[function]
export default WmcApi
